<template>
  <div class="app-container">
    <el-tabs type="border-card" @tab-click="tabsClick" v-model="tabVal">
      <el-tab-pane
        v-for="item in EXTERNAL_SERVICE_STATUS"
        :key="item.key"
        :name="item.key + ''"
        :label="item.value"
        v-loading="listLoading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="#e6ebf54d"
      >
        <el-form
          ref="form"
          label-width="250px"
          label-position="left"
          style="width: 80%;min-height: calc(100vh - 200px)"
        >
          <el-row :gutter="10">
            <!--              状态-->
            <el-col :xs="24" :sm="16" :xl="16">
              <el-form-item label="状态">
                <el-switch
                  v-model="settingData.status"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  :disabled="!isEdit"
                >
                </el-switch>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="8" :xl="8" style="text-align: right">
              <el-button type="primary" v-show="!isEdit" @click="isEdit = true"
                >编辑</el-button
              >
              <el-button
                type="success"
                v-show="isEdit"
                @click="saveOk"
                :loading="btnLoading"
                >保存</el-button
              >
            </el-col>
          </el-row>
          <!--          微信-->
          <div
            v-if="
              EXTERNAL_SERVICE_STATUS_.WECHAT === settingData.type &&
                settingData.status
            "
          >
            <el-form-item label="微信APPID">
              <span v-if="!isEdit">{{ settingData.content.appId }}</span>
              <el-input
                v-model="settingData.content.appId"
                placeholder="请输入"
                size="small"
                v-else
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item label="微信商户号">
              <span v-if="!isEdit">{{ settingData.content.mchId }}</span>
              <el-input
                style="width: 100%"
                v-model="settingData.content.mchId"
                placeholder="请输入"
                size="small"
                v-else
              />
            </el-form-item>
            <el-form-item label="公钥">
              <div v-if="!isEdit" class="key_pre">
                <span>{{ settingData.content.pubKey }}</span>
                <span
                  @click="copyClick(settingData.content.pubKey)"
                  class="copy_key_pre"
                  >复制</span
                >
              </div>
              <el-input
                style="width: 100%"
                v-model="settingData.content.pubKey"
                placeholder="请输入"
                size="small"
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 14 }"
                v-else
              />
            </el-form-item>
            <el-form-item label="私钥">
              <div v-if="!isEdit" class="key_pre">
                <span>{{ settingData.content.priKey }}</span>
                <span
                  @click="copyClick(settingData.content.priKey)"
                  class="copy_key_pre"
                  >复制</span
                >
              </div>
              <el-input
                style="width: 100%"
                v-model="settingData.content.priKey"
                placeholder="请输入"
                size="small"
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 14 }"
                v-else
              />
            </el-form-item>
            <el-form-item label="公钥ID">
              <span v-if="!isEdit">{{ settingData.content.pubKeyId }}</span>
              <el-input
                v-model="settingData.content.pubKeyId"
                placeholder="请输入"
                size="small"
                v-else
              />
            </el-form-item>
            <el-form-item label="商户序列号">
              <span v-if="!isEdit">{{ settingData.content.serNum }}</span>
              <el-input
                v-model="settingData.content.serNum"
                placeholder="请输入"
                size="small"
                v-else
              />
            </el-form-item>
            <el-form-item label="V3密钥">
              <div v-if="!isEdit" class="key_pre">
                <span> {{ settingData.content.v3Key }}</span>
                <span
                  @click="copyClick(settingData.content.v3Key)"
                  class="copy_key_pre"
                  >复制</span
                >
              </div>
              <el-input
                v-model="settingData.content.v3Key"
                placeholder="请输入"
                size="small"
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 14 }"
                v-else
              />
            </el-form-item>
          </div>

          <!--          支付宝-->
          <div
            v-if="
              EXTERNAL_SERVICE_STATUS_.ALIPAY === settingData.type &&
                settingData.status
            "
          >
            <el-form-item label="支付宝APPID">
              <span v-if="!isEdit">{{ settingData.content.appId }}</span>
              <el-input
                v-model="settingData.content.appId"
                placeholder="请输入"
                size="small"
                v-else
              />
            </el-form-item>
            <el-form-item label="应用私钥">
              <div v-if="!isEdit" class="key_pre">
                <span class="key_pre_value">{{
                  settingData.content.priKey
                }}</span>
                <span
                  @click="copyClick(settingData.content.priKey)"
                  class="copy_key_pre"
                  >复制</span
                >
              </div>
              <el-input
                v-model="settingData.content.priKey"
                placeholder="请输入"
                size="small"
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 14 }"
                v-else
              />
            </el-form-item>
            <el-form-item label="支付宝公钥">
              <div v-if="!isEdit" class="key_pre">
                <span class="key_pre_value">{{
                  settingData.content.aliPubKey
                }}</span>
                <span
                  @click="copyClick(settingData.content.aliPubKey)"
                  class="copy_key_pre"
                  >复制</span
                >
              </div>
              <el-input
                v-model="settingData.content.aliPubKey"
                placeholder="请输入"
                size="small"
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 14 }"
                v-else
              />
            </el-form-item>
          </div>

          <!--         jeep支付-->
          <div
            v-if="
              settingData.status &&
                [EXTERNAL_SERVICE_STATUS_.JEEP_PAY].includes(settingData.type)
            "
          >
            <el-form-item label="JeepayAPPID">
              <span v-if="!isEdit">{{ settingData.content.appId }}</span>
              <el-input
                v-model="settingData.content.appId"
                placeholder="请输入"
                size="small"
                v-else
              />
            </el-form-item>
            <el-form-item label="商户号">
              <span v-if="!isEdit">{{ settingData.content.mchId }}</span>
              <el-input
                v-model="settingData.content.mchId"
                placeholder="请输入"
                size="small"
                v-else
              />
            </el-form-item>
            <el-form-item label="API密钥">
              <div v-if="!isEdit" class="key_pre">
                <span>{{ settingData.content.apiKey }}</span>
                <span
                  @click="copyClick(settingData.content.apiKey)"
                  class="copy_key_pre"
                  >复制</span
                >
              </div>
              <el-input
                v-model="settingData.content.apiKey"
                placeholder="请输入"
                size="small"
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 14 }"
                v-else
              />
            </el-form-item>
          </div>

          <!--          壹玖-->
          <div
            v-if="
              settingData.status &&
                [EXTERNAL_SERVICE_STATUS_.YI_JIU].includes(settingData.type)
            "
          >
            <el-form-item label="壹玖APPID">
              <span v-if="!isEdit">{{ settingData.content.appId }}</span>
              <el-input
                v-model="settingData.content.appId"
                placeholder="请输入"
                size="small"
                v-else
              />
            </el-form-item>
            <el-form-item label="商户号">
              <span v-if="!isEdit">{{ settingData.content.mchId }}</span>
              <el-input
                v-model="settingData.content.mchId"
                placeholder="请输入"
                size="small"
                v-else
              />
            </el-form-item>
            <el-form-item label="API密钥">
              <div v-if="!isEdit" class="key_pre">
                <span>{{ settingData.content.apiKey }}</span>
                <span
                  @click="copyClick(settingData.content.apiKey)"
                  class="copy_key_pre"
                  >复制</span
                >
              </div>
              <el-input
                v-model="settingData.content.apiKey"
                placeholder="请输入"
                size="small"
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 14 }"
                v-else
              />
            </el-form-item>
            <el-form-item label="微信支付方式">
              <div v-if="!isEdit" class="key_pre">
                <span>{{
                  getValue(WECHAT_CODE, settingData.content.wechatCode)
                }}</span>
              </div>
              <el-select
                v-model="settingData.content.wechatCode"
                placeholder="请选择"
                style="width: 100%"
                class="filter-item"
                clearable
                v-else
              >
                <el-option
                  v-for="item in WECHAT_CODE"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="支付宝支付方式">
              <div v-if="!isEdit" class="key_pre">
                <span>{{
                  getValue(ALIPAY_CODE, settingData.content.alipayCode)
                }}</span>
              </div>
              <el-select
                v-model="settingData.content.alipayCode"
                placeholder="请选择"
                style="width: 100%"
                class="filter-item"
                clearable
                v-else
              >
                <el-option
                  v-for="item in ALIPAY_CODE"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                />
              </el-select>
            </el-form-item>
          </div>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import {
  getOutsideDetail,
  editYijiu,
  editWechat,
  editJeepay,
  editAli
} from "@/api/system.js";
import {
  getValue,
  EXTERNAL_SERVICE_STATUS,
  EXTERNAL_SERVICE_STATUS_,
  WECHAT_CODE,
  ALIPAY_CODE
} from "@/utils/enumUtile";
import { copyClick } from "@/utils/index.js";

export default {
  name: "index",
  computed: {
    EXTERNAL_SERVICE_STATUS() {
      return EXTERNAL_SERVICE_STATUS;
    },
    EXTERNAL_SERVICE_STATUS_() {
      return EXTERNAL_SERVICE_STATUS_;
    },
    WECHAT_CODE() {
      return WECHAT_CODE;
    },
    ALIPAY_CODE() {
      return ALIPAY_CODE;
    }
  },
  components: {},
  filters: {},
  data() {
    return {
      listLoading: false,
      tabVal: null,
      isEdit: false,
      btnLoading: false,
      settingData: {},
      rangeNumber: 10,
      itemSm: 24,
      itemXl: 24
    };
  },
  created() {
    const type = EXTERNAL_SERVICE_STATUS[0].key;
    this.getList(type);
  },
  watch: {},
  methods: {
    getValue,
    copyClick,
    /**
     * 查询用户列表
     */
    getList(type) {
      this.tabVal = type + "";
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      const params = {
        type
      };
      getOutsideDetail(params)
        .then(response => {
          let data = {};
          if (response && response.bizcode === 100) {
            data = response.data || {};
            if (data && Object.keys(data).length !== 0) {
              data.status = data.status === 1 ? true : false;
              if (!data.content) {
                data.content = this.addTr(type);
              } else {
                data.content = JSON.parse(data.content);
              }
            } else {
              const currentType = parseInt(type, 10);
              data.status = false;
              data.content = this.addTr(currentType);
              data.type = currentType;
            }
          }
          console.log("data", data);
          this.settingData = data;
        })
        .finally(() => {
          loading.close();
        });
    },
    /**
     * tab 切换
     * @param e
     */
    async tabsClick(e) {
      this.isEdit = false;
      this.settingData = {};
      this.getList(e.name);
    },
    /**
     * 保存
     */
    async saveOk() {
      const selTab = parseInt(this.tabVal, 10);
      const settingData = this.settingData;
      const params = {
        status: settingData.status ? 1 : 0,
        content: JSON.stringify(settingData.content)
      };
      let resp = null;
      if (selTab === EXTERNAL_SERVICE_STATUS_.JEEP_PAY) {
        // jeepay支付
        resp = await editJeepay(params);
      } else if (selTab === EXTERNAL_SERVICE_STATUS_.WECHAT) {
        // 微信
        resp = await editWechat(params);
      } else if (selTab === EXTERNAL_SERVICE_STATUS_.ALIPAY) {
        // 支付宝
        resp = await editAli(params);
      } else if (selTab === EXTERNAL_SERVICE_STATUS_.YI_JIU) {
        // 壹玖
        resp = await editYijiu(params);
      }
      if (resp && resp.bizcode === 100) {
        this.isEdit = false;
        this.getList(selTab);
        this.$notify({
          title: "成功",
          message: "保存成功",
          type: "success",
          duration: 2000
        });
      }
    },
    /**
     * 添加item
     * @param index
     */
    addTr(type) {
      console.log("type", type);
      let data = {};
      // 微信
      if (type === EXTERNAL_SERVICE_STATUS_.WECHAT) {
        data = {
          appId: null,
          mchId: null,
          pubKey: null,
          priKey: null,
          pubKeyId: null,
          serNum: null,
          v3Key: null
        };
      } else if (type === EXTERNAL_SERVICE_STATUS_.ALIPAY) {
        // 支付宝
        data = {
          appId: null,
          priKey: null,
          aliPubKey: null
        };
      } else if (EXTERNAL_SERVICE_STATUS_.JEEP_PAY === type) {
        // JEEP
        data = {
          appId: null,
          mchId: null,
          apiKey: null
        };
      } else if (EXTERNAL_SERVICE_STATUS_.YI_JIU === type) {
        // 壹玖
        data = {
          appId: null,
          mchId: null,
          apiKey: null,
          wechatCode: null,
          alipayCode: null
        };
      }
      return data;
    }
  }
};
</script>

<style lang="scss" scoped>
.fg_comm {
  width: 100%;
  margin: 10px 0 20px;
  border: 1px dashed #eeeeee;
}
::v-deep .el-card__header {
  padding: 0px;
}
.key_pre {
  //display: flex;
  //align-items: center;
  .key_pre_value {
    word-wrap: break-word;
    width: 100%;
  }
  .copy_key_pre {
    background-color: #11b95c;
    border-radius: 4px;
    color: #ffffff;
    height: 26px;
    line-height: 26px;
    margin-left: 20px;
    cursor: pointer;
    padding: 4px 8px;
    width: 30px;
  }
}
</style>
